import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import UserNav from "../user/UserNav.jsx";

const UserLayout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(true);       // sidebar open
  const [collapsed, setCollapsed] = useState(false); // icon mode

  const sidebarWidth = collapsed ? 80 : 200;

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (mobile) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ display: "flex" }}>
      
      {/* Sidebar */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: open ? sidebarWidth : "0px",
          transition: "all 0.3s ease",
          zIndex: 1000,
          overflow: "hidden",
          background: "#0f172a",
        }}
      >
        <UserNav
          open={open}
          setOpen={setOpen}
          isMobile={isMobile}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />
      </div>

      {/* Overlay */}
{isMobile && !open && (
  <button
    onClick={() => setOpen(true)}
    style={{
      position: "fixed",
      top: "10px",
      left: "10px",
      zIndex: 1100,
      background: "rgba(15,23,42,0.6)", // 👈 subtle glass bg
      border: "1px solid rgba(255,255,255,0.1)",
      color: "#fff",
      fontSize: "22px",
      padding: "5px",
      borderRadius: "10px",
      cursor: "pointer",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "10px",
    }}
  >
    <i className="bi bi-list"></i>
  </button>
)}

      {/* Content */}
      <div
        style={{
          marginLeft: isMobile ? 0 : open ? sidebarWidth : 0,
          transition: "margin 0.3s ease",
          height: "100vh",
          overflowY: "auto",
          width: "100%",
          paddingTop: isMobile ? "40px" : "0px",
          background: "linear-gradient(135deg, #0f172a, #020617)",

        }}
      >
        <div style={styles.glow1}></div>
      <div style={styles.glow2}></div>
        <Outlet />
      </div>
    </div>
  );
};

const styles = {
  
  glow1: {
    position: "absolute",
    width: "clamp(200px, 40vw, 400px)",
    height: "clamp(200px, 40vw, 400px)",
    background: "rgba(99,102,241,0.25)",
    filter: "blur(120px)",
    top: "-100px",
    left: "-100px",
    borderRadius: "50%",
  },

  glow2: {
    position: "absolute",
    width: "clamp(150px, 35vw, 300px)",
    height: "clamp(150px, 35vw, 300px)",
    background: "rgba(168,85,247,0.25)",
    filter: "blur(120px)",
    // bottom: "-100px",
    right: "-100px",
    borderRadius: "50%",
  },
}

export default UserLayout;